<template>
    <div id="app" :dir="languageMode">
        <router-view :key="$route.fullPath"></router-view>
        <!-- <router-view/> -->
        <!-- 모바일/PC/타블렛 화면 분기 시 사용할 수 있는 코드 주석 -->
        <!-- Code comments available for mobile/PC/Tablet screen branching -->
        <!-- <router-view v-if="isMobile()"/>
        <router-view v-else name="pcRouter"/> -->
    </div>
</template>

<script>
// Store 임포트
import {mapState} from 'vuex'
export default {
    name: 'Main',
    data() {
        return {

        }
    },

mounted() {
        this.root = document.documentElement;
        let checkColor= localStorage.getItem('--Primary')
        this.root.style.setProperty('--Primary', checkColor);

        let ccc =localStorage.getItem('--DocumentWhite')
        this.root.style.setProperty('--DocumentWhite', ccc);

        let blackColor =localStorage.getItem('--Black')
        this.root.style.setProperty('--Black', blackColor);

        let primaryInactiveColor =localStorage.getItem('--PrimaryInactive')
        this.root.style.setProperty('--PrimaryInactive', primaryInactiveColor);

        let secondaryColor =localStorage.getItem('--Secondary')
        this.root.style.setProperty('--Secondary', secondaryColor);

        let secondaryInactiveColor =localStorage.getItem('--SecondaryInactive')
        this.root.style.setProperty('--SecondaryInactive', secondaryInactiveColor);

        let mainbtnColor =localStorage.getItem('--Mainbtn')
        this.root.style.setProperty('--Mainbtn', mainbtnColor);

        let secondaryBtnColor =localStorage.getItem('--SecondaryBtn')
        this.root.style.setProperty('--SecondaryBtn', secondaryBtnColor);

        let snackbarsBtnColor =localStorage.getItem('--Snackbarsbtn')
        this.root.style.setProperty('--Snackbarsbtn', snackbarsBtnColor);

        let disableBtnColor =localStorage.getItem('--DisableBtn')
        this.root.style.setProperty('--DisableBtn', disableBtnColor);

        let navigationIconColor =localStorage.getItem('--Navigationicon')
        this.root.style.setProperty('--Navigationicon', navigationIconColor);

        let dividerColor =localStorage.getItem('--Divider')
        this.root.style.setProperty('--Divider',dividerColor);

        let snackbarsBgColor =localStorage.getItem('--Snackbarsbg')
        this.root.style.setProperty('--Snackbarsbg',snackbarsBgColor);

        let iconInactiveColor =localStorage.getItem('--Iconinactive')
        this.root.style.setProperty('--Iconinactive',iconInactiveColor);

        let iconInactiveTextColor =localStorage.getItem('--IconinactiveText')
        this.root.style.setProperty('--IconinactiveText',iconInactiveTextColor);

        let iconActiveColor =localStorage.getItem('--IconActive')
        this.root.style.setProperty('--IconActive',iconActiveColor);

        let appbarTextInactiveColor =localStorage.getItem('--AppbartextInactive')
        this.root.style.setProperty('--AppbartextInactive',appbarTextInactiveColor);

        let mainBtnTextColor =localStorage.getItem('--Mainbtntext')
        this.root.style.setProperty('--Mainbtntext',mainBtnTextColor);

        let secondaryBtnTextColor =localStorage.getItem('--Secondarybtntext')
        this.root.style.setProperty('--Secondarybtntext',secondaryBtnTextColor);

        let headlineBlackColor =localStorage.getItem('--HeadlineBlack')
        this.root.style.setProperty('--HeadlineBlack',headlineBlackColor);

        let bodyGrayAColor =localStorage.getItem('--BodygrayA')
        this.root.style.setProperty('--BodygrayA',bodyGrayAColor);

        let bodyGrayBColor =localStorage.getItem('--BodygrayB')
        this.root.style.setProperty('--BodygrayB',bodyGrayBColor);

        let bodyBlueGraykColor =localStorage.getItem('--Bodybluegray')
        this.root.style.setProperty('--Bodybluegray',bodyBlueGraykColor);

        let disableBtnTextColor =localStorage.getItem('--DisableBtnText')
        this.root.style.setProperty('--DisableBtnText',disableBtnTextColor);

        let whiteHighColor =localStorage.getItem('--WhiteHigh')
        this.root.style.setProperty('--WhiteHigh',whiteHighColor);

        let whiteMediumColor =localStorage.getItem('--WhiteMedium')
        this.root.style.setProperty('--WhiteMedium',whiteMediumColor);

        let whiteDisabledColor =localStorage.getItem('--WhiteDisabled')
        this.root.style.setProperty('--WhiteDisabled',whiteDisabledColor);

        let whiteBorderColor =localStorage.getItem('--WhiteBorder')
        this.root.style.setProperty('--WhiteBorder',whiteBorderColor);

        let textfieldGuidColor =localStorage.getItem('--Textfeildguid')
        this.root.style.setProperty('--Textfeildguid',textfieldGuidColor);

        let textfieldGuidLineColor =localStorage.getItem('--TextfeildguidLine')
        this.root.style.setProperty('--TextfeildguidLine',textfieldGuidLineColor);

        let textfieldActiveColor =localStorage.getItem('--Textfeildactive')
        this.root.style.setProperty('--Textfeildactive',textfieldActiveColor);

        let textfieldErrorColor =localStorage.getItem('--Textfeilderror')
        this.root.style.setProperty('--Textfeilderror',textfieldErrorColor);

        let saleLineColor =localStorage.getItem('--Saleline')
        this.root.style.setProperty('--Saleline',saleLineColor);

        let signGrayColor =localStorage.getItem('--SignGray')
        this.root.style.setProperty('--SignGray',signGrayColor);

        let signRedColor =localStorage.getItem('--SignRed')
        this.root.style.setProperty('--SignRed',signRedColor);

        let signBlueColor =localStorage.getItem('--SignBlue')
        this.root.style.setProperty('--SignBlue',signBlueColor);

        let contentBgColor =localStorage.getItem('--ContentsBG')
        this.root.style.setProperty('--ContentsBG',contentBgColor);

        let contentVariationColor =localStorage.getItem('--ContentVariation')
        this.root.style.setProperty('--ContentVariation',contentVariationColor);

        let contentVariationInactiveColor =localStorage.getItem('--ContentVariationInactive')
        this.root.style.setProperty('--ContentVariationInactive',contentVariationInactiveColor);

        let contentBlueColor =localStorage.getItem('--ContentBlue')
        this.root.style.setProperty('--ContentBlue',contentBlueColor);

        let contentBlueMidiumColor =localStorage.getItem('--ContentBlueMedium')
        this.root.style.setProperty('--ContentBlueMedium',contentBlueMidiumColor);

        let contentBlueInactiveColor =localStorage.getItem('--ContentBlueInactive')
        this.root.style.setProperty('--ContentBlueInactive',contentBlueInactiveColor);

        let redSelectColor =localStorage.getItem('--ContentRed')
        this.root.style.setProperty('--ContentRed',redSelectColor);

        let redContentRedSelectColor =localStorage.getItem('--ContentRedSelect')
        this.root.style.setProperty('--ContentRedSelect',redContentRedSelectColor);

        let starmarkColor =localStorage.getItem('--Starmark')
        this.root.style.setProperty('--Starmark',starmarkColor);

        let contentProgressBGColor =localStorage.getItem('--ContentProgressBG')
        this.root.style.setProperty('--ContentProgressBG',contentProgressBGColor);

        let contentTextColor =localStorage.getItem('--ContentText')
        this.root.style.setProperty('--ContentText',contentTextColor);

        let contentSubtextColor =localStorage.getItem('--ContentSubtext')
        this.root.style.setProperty('--ContentSubtext',contentSubtextColor);

        let documentGrayColor =localStorage.getItem('--DocumentGray')
        this.root.style.setProperty('--DocumentGray',documentGrayColor);

        let focusBlueColor =localStorage.getItem('--FocusBlue')
        this.root.style.setProperty('--FocusBlue',focusBlueColor);

        let linkBlueColor =localStorage.getItem('--LinkBlue')
        this.root.style.setProperty('--LinkBlue',linkBlueColor);

        let linkBgColor =localStorage.getItem('--LinkBG')
        this.root.style.setProperty('--LinkBG',linkBgColor);

        let quizBlackColor =localStorage.getItem('--QuizBlack')
        this.root.style.setProperty('--QuizBlack',quizBlackColor);

        let quizBlackInactiveColor =localStorage.getItem('--QuizBlackInactive')
        this.root.style.setProperty('--QuizBlackInactive',quizBlackInactiveColor);

        // let quizRedColor =localStorage.getItem('--QuizRed')
        // this.root.style.setProperty('--QuizRed',quizRedColor);

        // let quizBlueColor =localStorage.getItem('--QuizBlue')
        // this.root.style.setProperty('--QuizBlue',quizBlueColor);

        let quizGrayColor =localStorage.getItem('--QuizGray')
        this.root.style.setProperty('--QuizGray',quizGrayColor);

        let quizBlueGrayColor =localStorage.getItem('--QuizBluegray')
        this.root.style.setProperty('--QuizBluegray',quizBlueGrayColor);

        let quizWhiteColor =localStorage.getItem('--QuizWhite')
        this.root.style.setProperty('--QuizWhite',quizWhiteColor);

        let notiRedColor =localStorage.getItem('--NotiRed')
        this.root.style.setProperty('--NotiRed',notiRedColor);

        let notiGreenColor =localStorage.getItem('--NotiGreen')
        this.root.style.setProperty('--NotiGreen',notiGreenColor);

        let notiBlueColor =localStorage.getItem('--NotiBlue')
        this.root.style.setProperty('--NotiBlue',notiBlueColor);

        let tagGreenColor =localStorage.getItem('--TagGreen')
        this.root.style.setProperty('--TagGreen',tagGreenColor);

        let lectureRedColor =localStorage.getItem('--LectureRed')
        this.root.style.setProperty('--LectureRed',lectureRedColor);

        // let lectureRedBgColor =localStorage.getItem('--LectureRedBG')
        // this.root.style.setProperty('--LectureRedBG',lectureRedBgColor);

        let lectureRedBG16Color =localStorage.getItem('--LectureRedBG16')
        this.root.style.setProperty('--LectureRedBG16',lectureRedBG16Color);

        let lecturePurpleColor =localStorage.getItem('--LecturePurple')
        this.root.style.setProperty('--LecturePurple',lecturePurpleColor);

        // let lecturePurpleBgColor =localStorage.getItem('--LecturePurpleBG')
        // this.root.style.setProperty('--LecturePurpleBG',lecturePurpleBgColor);

        let lecturePurpleBG16Color =localStorage.getItem('--LecturePurpleBG16')
        this.root.style.setProperty('--LecturePurpleBG16',lecturePurpleBG16Color);

        let lectureYellowColor =localStorage.getItem('--LectureYellow')
        this.root.style.setProperty('--LectureYellow',lectureYellowColor);

        // let lectureYellowBgColor =localStorage.getItem('--LectureYellowBG')
        // this.root.style.setProperty('--LectureYellowBG',lectureYellowBgColor);

        let lectureYellowBG16Color =localStorage.getItem('--LectureYellowBG16')
        this.root.style.setProperty('--LectureYellowBG16',lectureYellowBG16Color);

        let lectureAquaColor =localStorage.getItem('--LectureAqua')
        this.root.style.setProperty('--LectureAqua',lectureAquaColor);

        // let lectureAquaBgColor =localStorage.getItem('--LectureAquaBG')
        // this.root.style.setProperty('--LectureAquaBG',lectureAquaBgColor);

        let lectureAquaBG16Color =localStorage.getItem('--LectureAquaBG16')
        this.root.style.setProperty('--LectureAquaBG16',lectureAquaBG16Color);

        let paymentBlueColor =localStorage.getItem('--PaymentBlue')
        this.root.style.setProperty('--PaymentBlue',paymentBlueColor);

        let newNoticeColor =localStorage.getItem('--Newnotice')
        this.root.style.setProperty('--Newnotice',newNoticeColor);

        let examRedColor =localStorage.getItem('--Examred')
        this.root.style.setProperty('--Examred',examRedColor);

        let examRedLineColor =localStorage.getItem('--ExamRedLine')
        this.root.style.setProperty('--ExamRedLine',examRedLineColor);

        let examGreenColor =localStorage.getItem('--Examgreen')
        this.root.style.setProperty('--Examgreen',examGreenColor);

        let examGreenLineColor =localStorage.getItem('--ExamGreenLine')
        this.root.style.setProperty('--ExamGreenLine',examGreenLineColor);

        let examBlueColor =localStorage.getItem('--Examblue')
        this.root.style.setProperty('--Examblue',examBlueColor);

        let examBlueLineColor =localStorage.getItem('--ExamBlueLine')
        this.root.style.setProperty('--ExamBlueLine',examBlueLineColor);

        let commentGrayColor =localStorage.getItem('--CommentGray')
        this.root.style.setProperty('--CommentGray',commentGrayColor);

        let commentBlueColor =localStorage.getItem('--CommentBlue')
        this.root.style.setProperty('--CommentBlue',commentBlueColor);

        let shadow1Color =localStorage.getItem('--Shadow1')
        this.root.style.setProperty('--Shadow1', shadow1Color);

        let shadow2Color =localStorage.getItem('--Shadow2')
        this.root.style.setProperty('--Shadow2', shadow2Color);

        let shadow3Color =localStorage.getItem('--Shadow3')
        this.root.style.setProperty('--Shadow3', shadow3Color);

        let contentsDimColor =localStorage.getItem('--ContentsDim')
        this.root.style.setProperty('--ContentsDim', contentsDimColor);
    },

    computed: {
        ...mapState(['languageMode'])
    },

    methods: {
        // Mobile Check
        disabledEvent(e) {
               if (e.stopPropagation) {
                   e.stopPropagation();
               } else if (window.event) {
                   window.event.cancelBubble = true;
               }
               e.preventDefault();
               return false;
           },
        isMobile() {
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },
    },
    watch:{
      $route(to,from){
        let html = document.documentElement // returns the html tag
        html.setAttribute('dir', this.languageMode)
      }
    }
}
</script>
<style lang="scss">
@import "@/scss/colors.scss";
</style>
